import { render } from "./App.vue?vue&type=template&id=0ae582bc&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=0ae582bc&lang=scss"

import exportComponent from "/Users/dev01/Documents/projects/metronic_v8.0.38/vue/demo1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__